import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useAuth } from 'services/auth-service';
import AccountService, { AccountProps } from 'services/hooks/account-service';
import BuildingService, { BuildingProps } from 'services/hooks/building-service';
import SelectInput from 'components/elements/Form/select/selectInput';
import SelectEntity from 'components/structure/Common/ListsEntity/SelectEntity';
import IntegrationService from 'services/hooks/integration-service';

//SET DEFAULT VALUES IF REQUIRED
export default function CSVRoleSelectionForm({ Controller, methods }: any) {
  const {
    state: { user }
  } = useAuth();

  const [accountOptions, setAccountOptions] = useState<any>([]);
  const [buildingOptions, setBuildingOptions] = useState<any>([]);
  const formatedOptions = (value: any, label: string) => {
    return { value: value, label: label };
  };

  const accountWatch = methods.watch('accountUuid');
  const [getAccountByIdResult, setGetAccountByIdResult] = useState<any>(undefined);

  // Fetch user specific Account data according to selected Account
  const { data: accountData, refetch: accountRefetch } = useQuery<AccountProps, Error>(
    'account',
    () => AccountService.findAccountById(accountWatch),
    {
      enabled: !!accountWatch && user.role === 'SUPER',
      onError: (err: any) => {
        console.log(err.response?.data || err);
      }
    }
  );

  // Fetch user specific Building data
  const { data: userBuildingData } = useQuery<BuildingProps, Error>(
    'building',
    () => BuildingService.findBuildingById(user.uuid),
    {
      enabled: user.role === 'BUILDING',
      onError: (err: any) => {
        console.log(err.response?.data || err);
      }
    }
  );

  // Fetch user specific Account data (If you want to display account in Building user)
  // const { data: userAccountData } = useQuery<AccountProps, Error>(
  //   'account',
  //   () =>
  //     AccountService.findAccountById(
  //       userBuildingData?.accountUuid ? userBuildingData?.accountUuid : user.uuid
  //     ),
  //   {
  //     enabled: user.role === 'ACCOUNT' || (!!userBuildingData && user.role === 'BUILDING'),
  //     onError: (err: any) => {
  //       console.log(err.response?.data || err);
  //     }
  //   }
  // );

  // Fetch user specific Account data
  const { data: userAccountData } = useQuery<AccountProps, Error>(
    'account',
    () => AccountService.findAccountById(user.uuid),
    {
      enabled: user.role === 'ACCOUNT',
      onError: (err: any) => {
        console.log(err.response?.data || err);
      }
    }
  );

  useEffect(() => {
    if (accountData && accountWatch) {
      accountRefetch();
      setGetAccountByIdResult(accountData);
    }
  }, [accountData, accountRefetch, accountWatch]);

  //UseEffect when the role is Super
  useEffect(() => {
    if (getAccountByIdResult && user.role === 'SUPER') {
      //To populate building options
      setBuildingOptions(
        getAccountByIdResult?.buildings?.map((building: { uuid: string; name: string }) =>
          formatedOptions(building.uuid, building.name)
        )
      );
    }
  }, [getAccountByIdResult, user]);

  //UseEffect when the role is Account
  useEffect(() => {
    if (userAccountData && user.role === 'ACCOUNT') {
      //To preload Account
      methods.setValue('accountUuid', userAccountData?.uuid);
      setAccountOptions([{ value: userAccountData?.uuid, label: userAccountData?.name }]);

      //To populate building options
      setBuildingOptions(
        userAccountData?.buildings?.map((building: { uuid?: string; name: string }) =>
          formatedOptions(building.uuid, building.name)
        )
      );
    }
  }, [methods, user, userAccountData]);

  //UseEffect when the role is Building
  useEffect(() => {
    if (userBuildingData && user.role === 'BUILDING') {
      //To preload Account (If you want to display account in Building user)
      // methods.setValue('accountUuid', userAccountData?.uuid);
      // setAccountOptions([{ value: userAccountData?.uuid, label: userAccountData?.name }]);

      //To preload Building
      methods.setValue('buildingUuid', userBuildingData.uuid);
      setBuildingOptions([{ value: userBuildingData?.uuid, label: userBuildingData?.name }]);
    }
  }, [methods, user, userBuildingData]);

  const renderRoleBasedDetails = () => {
    switch (user.role) {
      case 'SUPER':
        return (
          <div className="grid grid-cols-2 gap-4 mr-8">
            <SelectEntity
              Controller={Controller}
              control={methods.control}
              label="Choose Integration"
              placeholder="Select an Integration"
              queryname="integrations"
              name="integrationUuid"
              errors={methods.formState.errors}
              query={() => IntegrationService.findAllIntegrations()}
              expectedLabel="Integration/Name"
              multi={false}
            />
            <SelectEntity
              Controller={Controller}
              control={methods.control}
              label="Choose an Account"
              placeholder="Select Account"
              queryname="accounts"
              name="accountUuid"
              errors={methods.formState.errors}
              query={AccountService.findAllAccounts}
            />
            <SelectInput
              Controller={Controller}
              control={methods.control}
              label="Choose a Building"
              placeholder="Select Building"
              name="buildingUuid"
              errors={methods.formState.errors}
              options={buildingOptions}
            />
          </div>
        );
      case 'ACCOUNT':
        return (
          <div className="grid grid-cols-2 gap-4 mr-8">
            <SelectEntity
              Controller={Controller}
              control={methods.control}
              label="Choose Integration"
              placeholder="Select an Integration"
              queryname="integrations"
              name="integrationUuid"
              errors={methods.formState.errors}
              query={() => IntegrationService.findAllIntegrations()}
              expectedLabel="Integration/Name"
              multi={false}
            />
            <SelectInput
              Controller={Controller}
              control={methods.control}
              label="Choose an Account"
              name="accountUuid"
              errors={methods.formState.errors}
              disabled
              placeholder="Select Account"
              options={accountOptions}
            />
            <SelectInput
              Controller={Controller}
              control={methods.control}
              label="Choose a Building"
              placeholder="Select Building"
              name="buildingUuid"
              errors={methods.formState.errors}
              options={buildingOptions}
            />
          </div>
        );
      case 'BUILDING':
        return (
          <div className="grid grid-cols-2 gap-4 mr-8">
            <SelectEntity
              Controller={Controller}
              control={methods.control}
              label="Choose Integration"
              placeholder="Select an Integration"
              queryname="integrations"
              name="integrationUuid"
              errors={methods.formState.errors}
              query={() => IntegrationService.findAllIntegrations()}
              expectedLabel="Integration/Name"
              multi={false}
            />
            {/* (If you want to display account in Building user) 
            <SelectInput
              Controller={Controller}
              control={methods.control}
              label="Choose an Account"
              name="accountUuid"
              errors={methods.formState.errors}
              disabled
              placeholder="Select Account"
              options={accountOptions}
            /> */}
            <SelectInput
              Controller={Controller}
              control={methods.control}
              label="Choose a Building"
              placeholder="Select Building"
              name="buildingUuid"
              errors={methods.formState.errors}
              disabled={true}
              options={buildingOptions}
            />
          </div>
        );

      default:
        console.log('Role is missing');
        return null;
    }
  };

  return renderRoleBasedDetails();
}
